import React, {useEffect} from "react";

import "../../pages/3.css"
import "./blindMap.css"
import ReactTooltip from "react-tooltip";

const Tooltips = ({data, mapType}) => {

    let disabled = true;
    if (mapType === "FullyVisible") {
        disabled = false;
    }

    useEffect(() => {
        ReactTooltip.rebuild();
    });

    return (
        <React.Fragment>
            {data.map((d, i) => (
                    <ReactTooltip id={d.name} aria-haspopup='true' disable={disabled}>
                        <p className="tooltipParagraph">{d.name}</p>
                        <p className="tooltipParagraph">{d.latitude}</p>
                        <p className="tooltipParagraph">{d.longitude}</p>
                    </ReactTooltip>
                    ))}
        </React.Fragment>
    )
}

export default Tooltips